/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as RefundPolicyRouteImport } from './routes/refund-policy'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DeleteAccountRouteImport } from './routes/delete-account'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProtectedTaxRegimeSelectorRouteImport } from './routes/_protected.tax-regime-selector'
import { Route as ProtectedRewardsRouteImport } from './routes/_protected.rewards'
import { Route as ProtectedReferralsRouteImport } from './routes/_protected.referrals'
import { Route as ProtectedQuestionnaireRouteImport } from './routes/_protected.questionnaire'
import { Route as ProtectedProfileRouteImport } from './routes/_protected.profile'
import { Route as ProtectedItActRouteImport } from './routes/_protected.it-act'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected.dashboard'
import { Route as ProtectedServiceRequestIdRouteImport } from './routes/_protected.service-request.$id'
import { Route as ProtectedServiceRequestNewServiceTypeRouteImport } from './routes/_protected.service-request.new.$serviceType'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundPolicyRoute = RefundPolicyRouteImport.update({
  id: '/refund-policy',
  path: '/refund-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DeleteAccountRoute = DeleteAccountRouteImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedTaxRegimeSelectorRoute =
  ProtectedTaxRegimeSelectorRouteImport.update({
    id: '/tax-regime-selector',
    path: '/tax-regime-selector',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedRewardsRoute = ProtectedRewardsRouteImport.update({
  id: '/rewards',
  path: '/rewards',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedReferralsRoute = ProtectedReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedQuestionnaireRoute = ProtectedQuestionnaireRouteImport.update({
  id: '/questionnaire',
  path: '/questionnaire',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProfileRoute = ProtectedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedItActRoute = ProtectedItActRouteImport.update({
  id: '/it-act',
  path: '/it-act',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedServiceRequestIdRoute =
  ProtectedServiceRequestIdRouteImport.update({
    id: '/service-request/$id',
    path: '/service-request/$id',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedServiceRequestNewServiceTypeRoute =
  ProtectedServiceRequestNewServiceTypeRouteImport.update({
    id: '/service-request/new/$serviceType',
    path: '/service-request/new/$serviceType',
    getParentRoute: () => ProtectedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/delete-account': typeof DeleteAccountRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/refund-policy': typeof RefundPolicyRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/it-act': typeof ProtectedItActRoute
  '/profile': typeof ProtectedProfileRoute
  '/questionnaire': typeof ProtectedQuestionnaireRoute
  '/referrals': typeof ProtectedReferralsRoute
  '/rewards': typeof ProtectedRewardsRoute
  '/tax-regime-selector': typeof ProtectedTaxRegimeSelectorRoute
  '/service-request/$id': typeof ProtectedServiceRequestIdRoute
  '/service-request/new/$serviceType': typeof ProtectedServiceRequestNewServiceTypeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/delete-account': typeof DeleteAccountRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/refund-policy': typeof RefundPolicyRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/it-act': typeof ProtectedItActRoute
  '/profile': typeof ProtectedProfileRoute
  '/questionnaire': typeof ProtectedQuestionnaireRoute
  '/referrals': typeof ProtectedReferralsRoute
  '/rewards': typeof ProtectedRewardsRoute
  '/tax-regime-selector': typeof ProtectedTaxRegimeSelectorRoute
  '/service-request/$id': typeof ProtectedServiceRequestIdRoute
  '/service-request/new/$serviceType': typeof ProtectedServiceRequestNewServiceTypeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/delete-account': typeof DeleteAccountRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/refund-policy': typeof RefundPolicyRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/it-act': typeof ProtectedItActRoute
  '/_protected/profile': typeof ProtectedProfileRoute
  '/_protected/questionnaire': typeof ProtectedQuestionnaireRoute
  '/_protected/referrals': typeof ProtectedReferralsRoute
  '/_protected/rewards': typeof ProtectedRewardsRoute
  '/_protected/tax-regime-selector': typeof ProtectedTaxRegimeSelectorRoute
  '/_protected/service-request/$id': typeof ProtectedServiceRequestIdRoute
  '/_protected/service-request/new/$serviceType': typeof ProtectedServiceRequestNewServiceTypeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/delete-account'
    | '/login'
    | '/privacy'
    | '/refund-policy'
    | '/signup'
    | '/terms'
    | '/dashboard'
    | '/it-act'
    | '/profile'
    | '/questionnaire'
    | '/referrals'
    | '/rewards'
    | '/tax-regime-selector'
    | '/service-request/$id'
    | '/service-request/new/$serviceType'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/delete-account'
    | '/login'
    | '/privacy'
    | '/refund-policy'
    | '/signup'
    | '/terms'
    | '/dashboard'
    | '/it-act'
    | '/profile'
    | '/questionnaire'
    | '/referrals'
    | '/rewards'
    | '/tax-regime-selector'
    | '/service-request/$id'
    | '/service-request/new/$serviceType'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/delete-account'
    | '/login'
    | '/privacy'
    | '/refund-policy'
    | '/signup'
    | '/terms'
    | '/_protected/dashboard'
    | '/_protected/it-act'
    | '/_protected/profile'
    | '/_protected/questionnaire'
    | '/_protected/referrals'
    | '/_protected/rewards'
    | '/_protected/tax-regime-selector'
    | '/_protected/service-request/$id'
    | '/_protected/service-request/new/$serviceType'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  DeleteAccountRoute: typeof DeleteAccountRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  RefundPolicyRoute: typeof RefundPolicyRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refund-policy': {
      id: '/refund-policy'
      path: '/refund-policy'
      fullPath: '/refund-policy'
      preLoaderRoute: typeof RefundPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delete-account': {
      id: '/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof DeleteAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/tax-regime-selector': {
      id: '/_protected/tax-regime-selector'
      path: '/tax-regime-selector'
      fullPath: '/tax-regime-selector'
      preLoaderRoute: typeof ProtectedTaxRegimeSelectorRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/rewards': {
      id: '/_protected/rewards'
      path: '/rewards'
      fullPath: '/rewards'
      preLoaderRoute: typeof ProtectedRewardsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/referrals': {
      id: '/_protected/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof ProtectedReferralsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/questionnaire': {
      id: '/_protected/questionnaire'
      path: '/questionnaire'
      fullPath: '/questionnaire'
      preLoaderRoute: typeof ProtectedQuestionnaireRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/profile': {
      id: '/_protected/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProtectedProfileRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/it-act': {
      id: '/_protected/it-act'
      path: '/it-act'
      fullPath: '/it-act'
      preLoaderRoute: typeof ProtectedItActRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/service-request/$id': {
      id: '/_protected/service-request/$id'
      path: '/service-request/$id'
      fullPath: '/service-request/$id'
      preLoaderRoute: typeof ProtectedServiceRequestIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/service-request/new/$serviceType': {
      id: '/_protected/service-request/new/$serviceType'
      path: '/service-request/new/$serviceType'
      fullPath: '/service-request/new/$serviceType'
      preLoaderRoute: typeof ProtectedServiceRequestNewServiceTypeRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedRouteChildren {
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedItActRoute: typeof ProtectedItActRoute
  ProtectedProfileRoute: typeof ProtectedProfileRoute
  ProtectedQuestionnaireRoute: typeof ProtectedQuestionnaireRoute
  ProtectedReferralsRoute: typeof ProtectedReferralsRoute
  ProtectedRewardsRoute: typeof ProtectedRewardsRoute
  ProtectedTaxRegimeSelectorRoute: typeof ProtectedTaxRegimeSelectorRoute
  ProtectedServiceRequestIdRoute: typeof ProtectedServiceRequestIdRoute
  ProtectedServiceRequestNewServiceTypeRoute: typeof ProtectedServiceRequestNewServiceTypeRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedItActRoute: ProtectedItActRoute,
  ProtectedProfileRoute: ProtectedProfileRoute,
  ProtectedQuestionnaireRoute: ProtectedQuestionnaireRoute,
  ProtectedReferralsRoute: ProtectedReferralsRoute,
  ProtectedRewardsRoute: ProtectedRewardsRoute,
  ProtectedTaxRegimeSelectorRoute: ProtectedTaxRegimeSelectorRoute,
  ProtectedServiceRequestIdRoute: ProtectedServiceRequestIdRoute,
  ProtectedServiceRequestNewServiceTypeRoute:
    ProtectedServiceRequestNewServiceTypeRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  DeleteAccountRoute: DeleteAccountRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  RefundPolicyRoute: RefundPolicyRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
